import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './unitActionTypes';
import * as actions from './unitActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getUnitSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getUnits, payload);
    yield put(actions.getUnitDataAction(data));
  } catch (e) {
    yield put(actions.getUnitErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createUnitSaga(action) {
  try {
    console.log('createUnitSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create unit API payload:', payload);
    
    const { data } = yield call(endpoints.createUnit, payload);
    console.log('Create unit API response:', data);
    
    yield put(actions.createUnitDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/unit');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createUnitSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createUnitErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateUnitSaga(action) {
  try {
    console.log('updateUnitSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update unit API payload:', payload);
    
    const { data } = yield call(endpoints.updateUnit, payload);
    console.log('Update unit API response:', data);
    
    yield put(actions.updateUnitDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getUnitRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/unit');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateUnitSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateUnitErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteUnitSaga(action) {
  try {
    console.log('deleteUnitSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete unit API payload:', payload);
    
    const { data } = yield call(endpoints.deleteUnit, payload);
    console.log('Delete unit API response:', data);
    
    yield put(actions.deleteUnitDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getUnitRequestAction());
    }
    
  } catch (e) {
    console.error('deleteUnitSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteUnitErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* unitSaga() {
  yield all([
    takeEvery(types.GET_UNIT_REQUEST, getUnitSaga),
    takeEvery(types.CREATE_UNIT_REQUEST, createUnitSaga),
    takeEvery(types.UPDATE_UNIT_REQUEST, updateUnitSaga),
    takeEvery(types.DELETE_UNIT_REQUEST, deleteUnitSaga),
  ]);
}